/**
 * One colour per role — ROADMAP 9.10.
 *
 * Shared by the chip on a position row and the dialog that asks after a
 * drop, so a trader learns the colour once. Two components each picking
 * their own is how "the orange one" stops meaning anything.
 *
 * MAIN IS DELIBERATELY NOT COLOURED. The thesis is the default reading of a
 * leg; giving it a hue would paint every labelled basket and leave nothing
 * standing out. The two worth spotting across a list are the protection and
 * the thing that was added later.
 */

import type { LegRole } from '@apna/shared'

export const ROLE_TONE: Record<LegRole, { chip: string; dot: string }> = {
  MAIN: { chip: 'bg-secondary text-muted-foreground', dot: 'bg-muted-foreground/60' },
  HEDGE: { chip: 'bg-primary/10 text-primary', dot: 'bg-primary' },
  ADJUSTMENT: { chip: 'bg-warning/12 text-warning', dot: 'bg-warning' },
}
